<div fxLayout="row" class="snack-container" style="place-content: center">
  <div fxLayout="column" class="snack-container">
    <div fxLayout="row" style="text-align: center; align-self: center;">
      <mat-icon [color]="color" (click)="fecha()" style="font-size: 50px; height: 50px; width: 50px;">{{ icon }}</mat-icon>
      <br/>
    </div>
    <span [innerHTML]="data.message"></span>
    <mat-progress-bar id="progress-bar" mode="determinate" [value]="progress" color="warn" fxFlexOffset="5px"></mat-progress-bar>
  </div>
</div>
